import Api from './api';
import MApi from './merchant_api';

export default {
	/**
	 * Login user with credentials
	 *
	 */
	registration(credential) {
		const data = {
			nick: credential.email,
			pwd: credential.password,
			firstname: credential.firstname,
			lastname: credential.lastname,
			plan: credential.plan
		};

		return Api.post('account', data);
	},
	/**
	 * Login user with credentials
	 *
	 */
	login(credential) {
		const data = {
			nick: credential.email,
			pwd: credential.password
		};

		return Api.post('account/login', data);
	},
	/**
	 * Logout user with credentials
	 *
	 */
	logout() {
		return Api.delete('account');
	},
	/**
	 * Request reseting password email
	 *
	 */
	requestResetPassword(email) {
		const data = {
			address: email
		};
		return Api.post('account/pwd/forgot', data);
	},
	/**
	 * Reseting password by token
	 *
	 */
	resetPassword(token, password) {
		const data = {
			token,
			pwd: password
		};
		return Api.post('account/pwd/reset', data);
	},
	/**
	 * Change password
	 *
	 */
	changePassword(currentPwd, newPwd) {
		const data = {
			current: currentPwd,
			new: newPwd
		};
		return Api.post('account/pwd/change', data);
	},
	/**
	 * Getting account's PIN
	 *
	 */
	getCurrentPIN() {
		return Api.get('account/pin');
	},
	/**
	 * Renew the current PIN
	 *
	 */
	renewPIN() {
		return Api.put('account/pin');
	},
	/**
	 * Get account info
	 *
	 */
	getAccountInfo() {
		return Api.get('account');
	},
	/**
	 * Set account info
	 *
	 */
	setAccountInfo(credential) {
		const data = {
			firstname: credential.firstname,
			lastname: credential.lastname
		};
		return Api.put('account', data);
	},
	/**
	 * Update payment method
	 *
	 */
	setPaymentMethod(paymentType, nonce) {
		const data = {
			paymenttype: paymentType,
			nonce: nonce
		};
		return MApi.put('paymentmethod', data);
	},
	/**
	 * Update billing address
	 *
	 */
	setBillingAddress(credential) {
		const data = credential;
		return MApi.put('billingdetails', data);
	},
	/**
	 * Request confirmation
	 *
	 */
	requestConfirm(credential) {
		const data = {
			firstname: credential.firstname,
			lastname: credential.lastname,
			nick: credential.email
		};
		return Api.put('/account/confirm', data);
	},
	/**
	 * Confirm
	 *
	 */
	confirm(token) {
		return Api.get(`/account/confirm/${token}`);
	},
	/**
	 * Get the current API key
	 *
	 */
	getAPIKey() {
		return Api.get('account/apikey');
	},
	/**
	 * Renew the API key
	 *
	 */
	renewAPIKey() {
		return Api.put('account/apikey');
	},
	/**
	 * Get client token
	 *
	 */
	getClientToken() {
		return MApi.get('clienttoken');
	},
	/**
	 * Subscribe with credentials
	 *
	 */
	subscribe(planName, paymentType, nonce, credential) {
		const data = {
			plan: planName,
			paymenttype: paymentType,
			nonce: nonce,
			billingaddress: credential
		};

		return MApi.post('subscription', data);
	},
	/**
	 * Get plans
	 *
	 */
	getPlans() {
		return MApi.get(`plans`);
	},
	/**
	 * Get plan info
	 *
	 */
	getPlanInfo(plan) {
		return MApi.get(`plan/${plan}`);
	},
	/**
	 * Get VAT
	 *
	 */
	getVat(planName, credential) {
		const data = {
			plan: planName,
			billingaddress: credential
		};
		return MApi.post('subscription/estimate', data);
	},
	/**
	 * Get payment info
	 *
	 */
	getCustomerInfo() {
		return MApi.get('customer');
	},
	/**
	 * Get payment info
	 *
	 */
	getInvoices() {
		return MApi.get('invoices');
	},
	/**
	 * Download invoice
	 *
	 */
	openInvoiceInPDF(invoiceId) {
		var url = MApi.defaults.baseURL + 'invoice?invoice_id=' + invoiceId;
		window.open(url, '_blank');
	},
	/**
	 * Get user's subscription
	 *
	 */
	getSubscription() {
		return MApi.get('/subscription');
	},
	/**
	 * Get total price
	 *
	 */
	getTotalPrice() {
		return MApi.get('subscription/estimate');
	}
};



// WEBPACK FOOTER //
// ./app/services/user.js